import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const PrivateRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
        <img src="/assets/loading.gif" alt="Chargement..." className="w-24 h-24" />
        <p className="mt-6 text-lg text-paragaia font-semibold">Chargement...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  if (user.role !== 'client') {
    return <Navigate to="/" replace />;
  }

  if (
    location.pathname.startsWith('/admin') ||
    location.pathname === '/signin' ||
    location.pathname === '/signup'
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
